import { Injectable } from '@angular/core';
import { registrationInfo } from './registrationInfo';
import { gigyaInfo } from './gigyaInfo';


@Injectable({
  providedIn: 'root'
})
export class registrationListInfo {
    public registrationsListDto: registrationInfo[];
    public responseListDto: gigyaInfo[];
}